import {useSelector} from 'react-redux'
import {getOptimizedRoomsConfig} from 'modules/sapiSearch/selectors'
import {RootState} from 'store'

import {roomsToConfigurationObject} from '@vio/core/src/room/business/roomConfiguration'
import {GuestSplit} from '@vio/shared/src/search/GuestPicker/GuestSplitText'

import {useIsRoomsListImprovementsB} from './useIsRoomsListImprovementsB'

/**
 * Adults/children split of the optimized rooms config, on the B side of the
 * rooms list improvements only. `undefined` on the A side.
 */
export const useGuestSplit = (hotelId: string): GuestSplit | undefined => {
  const isRoomsListImprovementsB = useIsRoomsListImprovementsB()
  const roomsString = useSelector((state: RootState) =>
    getOptimizedRoomsConfig(state, hotelId)
  )

  if (!isRoomsListImprovementsB) return undefined

  const {numberOfAdults, numberOfChildren} =
    roomsToConfigurationObject(roomsString)
  return {numberOfAdults, numberOfChildren}
}
